import { DangerousHtmlContent } from '@eti/components';
import { css } from '@eti/styles';
import { useTranslation } from '@eti/providers';

const styles = css`
  color: #888;
  font-size: 0.625rem;
  font-style: italic;
  padding: 0 0.3125rem;
`;

const FinePrint = () => {
  const { t } = useTranslation();

  return (
    <DangerousHtmlContent className={styles} content={t('Postbooking.ProductPage.FinePrint')} />
  );
};

export default FinePrint;
